import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onResetFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-border bg-muted/30 py-16">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <Icon name="Package" size={32} className="text-muted-foreground" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-foreground">주문이 없습니다</h3>
      <p className="mb-6 text-center text-sm text-muted-foreground">
        현재 필터 조건에 맞는 주문이 없습니다.<br />
        필터를 초기화하거나 다른 조건으로 검색해보세요.
      </p>
      <Button
        variant="outline"
        iconName="RotateCcw"
        iconPosition="left"
        onClick={onResetFilters}
      >
        필터 초기화
      </Button>
    </div>
  );
};

export default EmptyState;